module.exports = new __parcel__URL__("bossfight_boss_rare.e791433f.png").toString();